import { FC, Fragment, ReactNode } from 'react';

import { Breadcrumb, BreadcrumbLink, Button, Drawer } from '@servicetitan/design-system';

import { JsonSchema, JsonSchemaCollection, JsonSchemaOrRef } from '../../api/documentation.api';
import { getSchemaDetailsHeader } from '../utils';
import { SchemaDescription } from './schema-description';
import { SchemaDetails } from './schema-details';

export const SchemaDetailsDrawer: FC<{
    schemas: JsonSchemaCollection;
    selectedSchemaNames: string[];
    setSelectedSchemaNames: (names: string[]) => void;
    formatSchemaType: (schema: JsonSchemaOrRef) => ReactNode;
    resolveSchemaRef: (ref: string) => JsonSchema;
    onClose: () => void;
}> = ({
    schemas,
    selectedSchemaNames,
    setSelectedSchemaNames,
    formatSchemaType,
    resolveSchemaRef,
    onClose,
}) => {
    const name = selectedSchemaNames[selectedSchemaNames.length - 1];
    const schema = schemas[name];
    return (
        <Drawer
            width="l"
            header={
                <Fragment>
                    <Button
                        className="m-r-2"
                        fill="subtle"
                        iconName="arrow_back"
                        xsmall
                        aria-label="Back"
                        onClick={() => {
                            setSelectedSchemaNames(
                                selectedSchemaNames.slice(0, selectedSchemaNames.length - 1),
                            );
                        }}
                    />
                    {getSchemaDetailsHeader(name, schema)}
                </Fragment>
            }
            backdrop
            open
            onClose={onClose}
        >
            {selectedSchemaNames.length > 1 && (
                <Breadcrumb className="m-b-3">
                    {selectedSchemaNames.map((name, index) => (
                        <BreadcrumbLink
                            key={name}
                            label={getSchemaDetailsHeader(name, schemas[name])}
                            onClick={
                                index < selectedSchemaNames.length - 1
                                    ? () => {
                                          setSelectedSchemaNames(
                                              selectedSchemaNames.slice(0, index + 1),
                                          );
                                      }
                                    : undefined
                            }
                        />
                    ))}
                </Breadcrumb>
            )}
            <SchemaDescription schema={schema} resolveSchemaRef={resolveSchemaRef} />
            <SchemaDetails
                name={name}
                schema={schema}
                formatSchemaType={formatSchemaType}
                resolveSchemaRef={resolveSchemaRef}
            />
        </Drawer>
    );
};
SchemaDetailsDrawer.displayName = 'SchemaDetailsDrawer';
